import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

export interface AsyncFormSelectorState {
  [key: string]: { label: string; value: string };
}

const initialState: AsyncFormSelectorState = {};

export const dropdownSelector = createSlice({
  name: "dropdownSelector",
  initialState,
  reducers: {
    setAsyncFormSelector: (state, { payload }) => {
      const { name, value, label, type } = payload;

      if (type === "removeValue") {
        delete state[name];
      } else {
        state[name] = { label, value };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { setAsyncFormSelector } = dropdownSelector.actions;

export default dropdownSelector.reducer;
